import { observer } from 'mobx-react';
import React, { SyntheticEvent, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { FormattedMessage } from 'react-intl';
import SlidingPanel from 'react-sliding-side-panel';
import 'react-sliding-side-panel/lib/index.css';
import noMessageIcon from '../../assets/Images/no-tray.png';
import { ModuleType } from '../../constants/enums/module-type-enum';
import TrayStatusEnum from '../../constants/enums/tray-status-enum';
import userSettingEnum from '../../constants/enums/user-setting-enum';
import { useStore } from '../../contexts/store-provider';
import {
  TrayDefaultSortColumnOrder,
  TrayFilterInitialState,
} from '../../core/initialState/filter-initial-state';
import {
  isOperationPermittedRoleBase,
  showIconsRoleBase,
} from '../../helpers/action-permission-helper';
import { getTenantIdFromLocalStorage } from '../../helpers/localstorage-helper';
import IPageInfo, {
  IActionFormatter,
  IPageLimitInfo,
} from '../../models/ICommon';
import IDefaultColumSortOrder from '../../models/IDefaultColumSortOrder';
import { ITrayFilter } from '../../models/ITrayFilter';
import FormLoader from '../../shared-components/FormLoader/FormLoader';
import Grid from '../../shared-components/Grid/Grid';
import { CustomActionFormatter } from '../../shared-components/Grid/GridFormatter';
import Pagination from '../../shared-components/Grid/Pagination';
import Header from '../../shared-components/header/header';
import FilterPopupHOC from '../../shared-components/hoc/filter-popup-hoc/filter-popup-hoc';
import DeletePopup from '../../shared-components/popup/delete/delete-popup';
import DeletePopupHOC from '../../shared-components/popup/delete/delete-popup-hoc';
import { Form as BsForm, Button } from 'react-bootstrap';

import {
  CloseSidePanelIcon,
  DeleteIcon,
  EditIcon,
  ExportTrayIcon,
  HistoryIcon,
  PlusIcon,
  RefreshIcon,
} from '../../shared-components/svgs/svgs';
import { formatMessage } from '../../translations/format-message';
import AddEditTrayManagement from './components/add-edit-tray-management';
import FilterComponent from './components/filter';
import ImportTrayDetails from './components/import-tray-details';
import AddEditTrayManagementPopupHOC from './hoc/add-edit-tray-management-popup-hoc';
import ImportTrayDetailsPopupHOC from './hoc/import-tray-details-popup-hoc';
import TrayDetails from './tray-details';
import './tray-management.css';
import TrayPrintFilesHistoryDetails from './tray-print-files-history-details';
import { formatDate } from 'date-fns';

const TrayManagement = (props: any) => {
  const { preferencesStore, trayManagementStore } = useStore();
  const {
    GetTrayListService,
    getTrayListServiceState,
    allTrays,
    trayList,
    deleteTrayState,
    trayState,
    DeleteTrayService,
    resetDeleteTray,
    resetTrayDetail,
    addUpdateTrayState,
    resetAddUpdateTrayState,
    fileUploadState,
    resetFileUploadState,
    duplicateData,
    getTrayFilesHistoryState,
    getDownloadrayFilesHistoryState,
    base64String,
    resetExportFileState,
    GetTrayReportService,
    getTrayReportState,
    resetGetTrayReportState,
  } = trayManagementStore;

  const {
    userSetting,
    setUserSetting,
    language,
    islanguageChanged,
    updateLanguageChangedFlag,
  } = preferencesStore;

  let lang: string;
  const allTrayListData = allTrays;
  const [columSortOrder, setColumnSortOrder] = useState<IDefaultColumSortOrder>(
    TrayDefaultSortColumnOrder
  );
  const [noBackdrop, setNoBackdrop] = useState<boolean>(false);
  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [selectedId, setSelectedId] = useState(0);
  const [selectedRowTrayId, setSelectedRowTrayId] = useState('');
  const [openPanel, setOpenPanel] = useState(false);
  const pageLimitOptions: Array<number> = [10, 20, 50, 100];
  const [isFilterCleared, setIsFilterCleared] = useState(true);
  const [showCompletedTrays, setShowCompletedTrays] = useState(false);

  const [filterObj, setFilterObj] = useState<ITrayFilter>(
    TrayFilterInitialState
  );
  const [openHistoryPanel, setOpenHistoryPanel] = useState(false);

  const [isFilterApplied, setIsFilterApplied] = useState<boolean>(false);

  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.pageLimitConfig,
    isPageLimitChange: false,
  });

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });

  const onPageChanged = (pageNumber: number) => {
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageLimitChanged = (evt: any) => {
    let pages: number;
    pages = props.data && Math.ceil(props.data.length / evt.target.value);
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages: pages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.UserLimitConfig, parseInt(evt.target.value));
  };

  const getTrayListServiceHandler = (
    filterQuery?: string,
    isFilter = false
  ) => {
    if (!filterQuery) {
      filterQuery = createQueryString({
        ...filterObj,
        IsComplete: showCompletedTrays,
        Column: columSortOrder.dataField,
        Order: columSortOrder.order,
      });
    }
    if (!isFilter) {
      GetTrayListService(
        Number(getTenantIdFromLocalStorage()),
        pageLimitInfo.pageLimit,
        pageInfo.currentPage,
        encodeURIComponent(filterQuery)
      );
    } else {
      GetTrayListService(
        Number(getTenantIdFromLocalStorage()),
        pageLimitInfo.pageLimit,
        1,
        encodeURIComponent(filterQuery)
      );
    }
  };

  const openImportFileHandler = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    closePanelHandler();
    props.addToggleHandler();
    resetTrayDetail();
  };

  useEffect(() => {
    getTrayListServiceHandler();
  }, []);

  useEffect(() => {
    if (islanguageChanged) {
      updateLanguageChangedFlag();
    }
  }, [islanguageChanged]);

  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      currentPage: trayList?.PagingDetails?.CurrentPage,
      totalPages: trayList?.PagingDetails?.TotalPages,
      isPagerChange: false,
    });
    setDisablePagination(false);
  }, [trayList]);

  useEffect(() => {
    if (pageInfo.isPagerChange) {
      getTrayListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      getTrayListServiceHandler();
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
  }, [pageLimitInfo.pageLimit]);

  useEffect(() => {
    if (lang && language !== lang) {
      getTrayListServiceHandler();
    }
  }, [language]);

  useEffect(() => {
    if (fileUploadState.success) {
      toast.success(` ${formatMessage(duplicateData)}`);
      resetFileUploadState();
      getTrayListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileUploadState.success]);

  useEffect(() => {
    if (addUpdateTrayState.success) {
      resetAddUpdateTrayState();
      getTrayListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUpdateTrayState.success]);

  useEffect(() => {
    if (deleteTrayState.success) {
      toast.success(formatMessage('deleted_success'));
      props.deletePopupToggleHandler();
      resetDeleteTray();
      getTrayListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteTrayState.success]);

  function rowClassFormat(row: any, rowId: number) {
    let className: string = '';
    if (selectedRow?.Id && row.Id === selectedRow.Id) {
      className = 'bg-row SelectedRow';
    }
    if (row.CurrentState === TrayStatusEnum.Complete) {
      className = 'active-tray-row';
    }
    return className;
  }

  const rowEvents = (e: SyntheticEvent, row: any) => {
    setSelectedRow(row);
    setOpenHistoryPanel(false);
    if (selectedRow.Id === undefined || selectedRow.Id !== row.Id) {
      setOpenPanel(true);
    } else {
      setOpenPanel(!openPanel);
    }
  };

  const toggleHistoryDetails = () => {
    if (openHistoryPanel) {
      setOpenPanel(false);
    }

    if (!openPanel) {
      setOpenPanel((prev) => !prev);
    }

    setOpenHistoryPanel((prev) => !prev);
  };

  const closePanelHandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
    setOpenHistoryPanel(false);
  };

  const refreshClickHandler = () => {
    const filter = createQueryString({
      ...filterObj,
      IsComplete: showCompletedTrays,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    });
    getTrayListServiceHandler(filter);
    closePanelHandler();
  };

  const deleteHandler = () => {
    DeleteTrayService(Number(getTenantIdFromLocalStorage()), selectedId);
  };

  const deleteClickHandler = (
    row: any,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setSelectedRowTrayId(row.TrayId);
    setSelectedId(row.Id);
    event.stopPropagation();
    closePanelHandler();
    resetTrayDetail();
    props.deletePopupToggleHandler();
  };

  const openAddTrayHandler = (
    row: { Id: number },
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    closePanelHandler();
    resetTrayDetail();
    setSelectedId(row.Id);
    props.addTrayToggleHandler();
  };

  const exportTrayReportClickHandler = (
    row: any,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    closePanelHandler();
    resetTrayDetail();
    GetTrayReportService(
      Number(getTenantIdFromLocalStorage()),
      row.Id,
      row.TrayId
    );
    setSelectedRowTrayId(row.TrayId);
    // setSelectedId(row.Id);
    // props.deletePopupToggleHandler();
  };

  const handleExport = (base64Data: string) => {
    // Decode the base64 string
    const binaryData = atob(base64Data);
    const binaryArray = new Uint8Array(binaryData.length);

    // Fill the binary array with the decoded binary data
    for (let i = 0; i < binaryData.length; i++) {
      binaryArray[i] = binaryData.charCodeAt(i);
    }

    // Create a Blob from the binary data with the MIME type for Excel
    const blob = new Blob([binaryArray], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    // Create a URL for the Blob and set up the download link
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `TrayHistory-${Date.now()}.csv`;

    // Trigger the download by simulating a click on the link
    document.body.appendChild(link);
    link.click();

    // Clean up and remove the link after download
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    // closePanelHandler();
    // resetFactoryScheduleDetail();
  };

  const handleExportTray = (base64Data: string) => {
    // Decode the base64 string
    const binaryData = atob(base64Data);
    const binaryArray = new Uint8Array(binaryData.length);

    // Fill the binary array with the decoded binary data
    for (let i = 0; i < binaryData.length; i++) {
      binaryArray[i] = binaryData.charCodeAt(i);
    }

    // Create a Blob from the binary data with the MIME type for Excel
    const blob = new Blob([binaryArray], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    // Create a URL for the Blob and set up the download link
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `TrayReport_${selectedRowTrayId}.csv`;

    // Trigger the download by simulating a click on the link
    document.body.appendChild(link);
    link.click();

    // Clean up and remove the link after download
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const toggleShowCompletedTrays = (e: any, isCompleted: boolean) => {
    const queryString = createQueryString({
      ...filterObj,
      Column: getFieldName(columSortOrder.dataField),
      Order: columSortOrder.order,
      IsComplete: isCompleted,
    });

    // setSelectedCodeIds([]);
    // setSelectedIds([]);
    // setSelectedRows([]);
    // setSelectedGroupSettingDetails([]);
    // setRightSelectedData([]);
    getTrayListServiceHandler(queryString, true);
    setShowCompletedTrays(isCompleted);
    setFilterObj((prev) => ({
      ...prev,
      IsComplete: isCompleted,
    }));
    // setIsGroupSelected(e.target.checked);

    // if (e.target.checked) {
    //   GetAllGroupSettingService(Number(getTenantIdFromLocalStorage()));
    // }

    // if (selectedGroup.length > 0) {
    //   GetGroupSettingByNameService(
    //     Number(getTenantIdFromLocalStorage()),
    //     selectedGroup
    //   );
    // }

    //Sometimes the selected group details are not showing so we added this code.
    // setSelectedGroupSettingDetails([...groupsByNameList]);
  };

  useEffect(() => {
    if (
      getDownloadrayFilesHistoryState.success &&
      base64String.fileString.length > 0
    ) {
      handleExport(base64String.fileString);
      resetExportFileState();
    }
  }, [getDownloadrayFilesHistoryState.success]);

  useEffect(() => {
    if (getTrayReportState.success && base64String.fileString.length > 0) {
      handleExportTray(base64String.fileString);
      resetGetTrayReportState();
    }
  }, [getTrayReportState.success]);

  function getFieldName(field: string): string {
    switch (field) {
      case 'TrayId':
        return 'tray_id';
      case 'OrderId':
        return 'order_id';
      case 'EUOrderNo':
        return 'eu_order_no';
      case 'CustomerDueDate':
        return 'customer_due_date';
      case 'PlanedDueDate':
        return 'planed_due_date';
      case 'ProductId':
        return 'product_id';
      case 'CustomerId':
        return 'customer_id';
      default:
        return 'tray_id';
    }
  }

  const createQueryString = (filter: ITrayFilter): string => {
    return Object.entries(filter)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('#');
  };

  const filterHandler = (object: ITrayFilter) => {
    const filter = createQueryString({
      ...object,
      Column: getFieldName(columSortOrder.dataField),
      Order: columSortOrder.order,
      IsComplete: showCompletedTrays,
    });
    getTrayListServiceHandler(filter, true);
    setFilterObj({
      ...object,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
      IsComplete: showCompletedTrays,
    });
    props.filterPopupToggleHandler();
    closePanelhandler();
    setIsFilterCleared(false);
  };

  const closePanelhandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
    // resetGetFactoryDetail();
  };

  const filterParams = (obj: ITrayFilter, isfilterCleard: boolean) => {
    const filter = createQueryString({
      ...obj,
      Column: getFieldName(columSortOrder.dataField),
      Order: columSortOrder.order,
      IsComplete: isfilterCleard ? false : showCompletedTrays,
    });

    if (isfilterCleard) {
      setFilterObj({ ...obj });
      setShowCompletedTrays(false);
      getTrayListServiceHandler(filter);
      closePanelhandler();
      setIsFilterCleared(true);
    } else {
      setFilterObj({ ...obj });
    }
    props.filterPopupToggleHandler();
  };

  const handleTableChange = (type: any, newState: any) => {
    if (
      newState.sortField !== columSortOrder.dataField ||
      newState.sortOrder !== columSortOrder.order
    ) {
      setColumnSortOrder({
        ...columSortOrder,
        dataField: newState.sortField,
        order: newState.sortOrder,
      });
      const filter = createQueryString({
        ...filterObj,
        Column: newState.sortField,
        Order: newState.sortOrder,
        IsComplete: showCompletedTrays,
      });
      getTrayListServiceHandler(filter, true);
    }
  };

  const actionIcons: IActionFormatter[] = showIconsRoleBase(
    [
      {
        dataField: 'trayExport',
        handler: exportTrayReportClickHandler,
        // handler: {},
        icon: <ExportTrayIcon />,
        isDisable: false,
        title: 'export',
        varient: 'success',
        action: 'export',
      },
      {
        dataField: 'isEdit',
        handler: openAddTrayHandler,
        icon: <EditIcon />,
        isDisable: !isOperationPermittedRoleBase(
          ModuleType.TrayManagement,
          'Edit'
        ),
        title: 'edit',
        varient: 'primary',
        action: 'edit',
      },
      {
        dataField: 'isDelete',
        handler: deleteClickHandler,
        icon: <DeleteIcon />,
        isDisable: !isOperationPermittedRoleBase(
          ModuleType.TrayManagement,
          'Delete'
        ),
        title: 'delete',
        varient: 'danger',
        action: 'delete',
      },
    ],
    ModuleType.TrayManagement
  );

  const columns: any = [
    {
      dataField: 'serialNumber',
      text: formatMessage('serial_number'),
      classes: 'show-Elipses',
      isDummyField: true,
      formatter: (_: any, __: any, rowIndex: number) => rowIndex + 1,
      sort: false,
    },

    {
      dataField: 'TrayId',
      text: formatMessage('tray_id'),
      classes: 'show-Elipses',
      sort: true,
    },
    {
      dataField: 'CustomerId',
      text: formatMessage('customer_id'),
      classes: 'show-Elipses',
      sort: true,
    },
    {
      dataField: 'CustomerDueDate',
      text: formatMessage('customer_due_date'),
      classes: 'show-Elipses',
      sort: true,
      // formatter: (cell) => {
      //   return cell && cell !== '-'
      //     ? convertNonUTCDateToLocalTimeZone(cell.toString())
      //     : '-';
      // },
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
    },

    {
      dataField: 'EndUserName',
      text: formatMessage('end_user_name'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'EndUserOrderId',
      text: formatMessage('end_user_order_id'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    // {
    //   dataField: 'TenantId',
    //   text: formatMessage('tenant_id'),
    //   classes: 'show-Elipses',
    // },
    {
      dataField: 'OrderId',
      text: formatMessage('order_id'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'SubContractor',
      text: formatMessage('sub_contractor'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'SubContractorName',
      text: formatMessage('sub_contractor_name'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'ProductName',
      text: formatMessage('product_id'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'Katashiki1',
      text: formatMessage('katashiki_1'),
      // classes: 'show-Elipses',
      formatter: (cell) => {
        return cell && cell.length > 33 ? cell.substring(0, 33) + '...' : cell;
      },
      title: (cell: string) => {
        return cell.length > 33 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'Katashiki2',
      text: formatMessage('katashiki_2'),
      // classes: 'show-Elipses',
      formatter: (cell) => {
        return cell && cell.length > 33 ? cell.substring(0, 33) + '...' : cell;
      },
      title: (cell: string) => {
        return cell.length > 33 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'Kishu',
      text: formatMessage('kishu'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'ProcessName',
      text: formatMessage('process_name'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      sort: true,
      hidden: true,
    },
    {
      dataField: 'Quantity',
      text: formatMessage('quantity'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'InvoiceNumber',
      text: formatMessage('invoice_number'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'QuantityUnitName',
      text: formatMessage('quantity_unit_name'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'MissingParts',
      text: formatMessage('missing_parts'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'TagId',
      text: formatMessage('tag_id'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        // return cell.length > 10 ? cell : undefined;
      },
      sort: !showCompletedTrays,
    },
    {
      dataField: 'ProductComment1',
      text: formatMessage('product_comment_1'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        // return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'ProductComment2',
      text: formatMessage('product_comment_2'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        // return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'ProductComment3',
      text: formatMessage('product_comment_3'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        // return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'ProductComment4',
      text: formatMessage('product_comment_4'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        // return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'ProductComment5',
      text: formatMessage('product_comment_5'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        // return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'ProductComment6',
      text: formatMessage('product_comment_6'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        // return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },

    {
      dataField: 'PlanedDueDate',
      text: formatMessage('planned_due_dates'),
      classes: 'show-Elipses',
      // formatter: (cell) => {
      //   return cell && cell !== '-'
      //     ? convertNonUTCDateToLocalTimeZone(cell.toString())
      //     : '-';
      // },
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      hidden: true,
    },
    {
      dataField: '',
      formatter: CustomActionFormatter(actionIcons),
      text: formatMessage('actions'),
      classes: 'last-column',
      hidden: actionIcons.length > 0 ? false : true,
    },
  ];
  return (
    <>
      {props.showImportPopup && (
        <ImportTrayDetails
          id={selectedId}
          modalClosed={props.addToggleHandler}
        />
      )}

      {props.showAddTrayManagementPopup && (
        <AddEditTrayManagement
          id={selectedId}
          modalClosed={props.addTrayToggleHandler}
        />
      )}
      {props.showDeletePopup && (
        <DeletePopup
          title="delete_tray"
          modalSubmit={deleteHandler}
          modalClosed={props.deletePopupToggleHandler}
          message="message_delete_tray_confirm"
          isLoading={deleteTrayState.inProgress}
          id={selectedRowTrayId}
        />
      )}
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <Header
            className="col"
            label="tray_management"
          />
          <div className="col-auto">
            <ul className="add-list">
              <li>
                <FilterComponent
                  initialValues={filterObj}
                  id={0}
                  submitHandler={filterHandler}
                  filterParmas={filterParams}
                  onModalClosed={props.filterPopupToggleHandler}
                  isLoading={false}
                  isDisable={
                    false
                    // getTenantIdFromLocalStorage() === "-1" &&
                    // selectedTenantId === -1
                  }
                  // isFilterCleared={false}
                  isFilterCleared={isFilterCleared}
                  isFilterApplied={isFilterApplied}
                  setIsFilterApplied={setIsFilterApplied}
                />
              </li>
              <li title={formatMessage('refresh')}>
                <a
                  data-toggle="modal"
                  className="btn btn-light"
                  onClick={() => refreshClickHandler()}
                >
                  <RefreshIcon />
                </a>
              </li>
              {isOperationPermittedRoleBase(
                ModuleType.TrayManagement,
                'Add'
              ) && (
                <li title={formatMessage('import')}>
                  <a
                    data-toggle="modal"
                    className={`btn btn-light`}
                    onClick={(event: any) => openImportFileHandler(event)}
                  >
                    <svg
                      version="1.1"
                      id="Capa_1"
                      fill="currentColor"
                      width="20"
                      height="20"
                      x="0px"
                      y="0px"
                      viewBox="0 0 405.2 512"
                    >
                      <g>
                        <path
                          d="M214.1,314.1l40-40c7.8-7.8,7.8-20.5,0-28.3s-20.5-7.8-28.3,0l-5.9,5.9V180c0-11-9-20-20-20s-20,9-20,20v71.7l-5.9-5.9
    c-7.8-7.8-20.5-7.8-28.3,0s-7.8,20.5,0,28.3l40,40C193.6,321.9,206.4,321.9,214.1,314.1L214.1,314.1z"
                        />
                        <path
                          d="M394.1,125.8l-120-120C273.9,5.7,268.7,0,260,0H60C26.9,0,0,26.9,0,60v392c0,33.1,26.9,60,60,60h40c11,0,20-9,20-20
    s-9-20-20-20H60c-11,0-20-9-20-20V60c0-11,9-20,20-20h180v60c0,33.1,26.9,60,60,60h60v140c0,11,9,20,20,20s20-9,20-20V140
    C400,134.7,397.9,129.6,394.1,125.8L394.1,125.8z M300,120c-11,0-20-9-20-20V68.3l51.7,51.7H300z"
                        />
                      </g>
                      <g>
                        <path
                          d="M156.2,449.4c0,22.5,9.4,33.7,28.3,33.7c3.4,0,6.6-0.3,9.6-1s6.7-1.7,11-3.2c3.5,7.6,5.8,15.5,7,23.5
    c-3.1,1.2-5.9,2.1-8.6,2.9c-2.6,0.7-5.2,1.3-7.6,1.7c-2.4,0.4-4.8,0.6-7.2,0.8c-2.4,0.2-4.8,0.2-7.4,0.2c-9,0-16.9-1.5-23.8-4.4
    c-6.8-2.9-12.6-7-17.2-12.2c-4.6-5.2-8.1-11.4-10.4-18.6c-2.3-7.2-3.5-15-3.5-23.5c0-8.5,1.2-16.3,3.7-23.6
    c2.4-7.3,6-13.5,10.6-18.8c4.6-5.3,10.3-9.4,17.1-12.4c6.8-3,14.5-4.4,23-4.4c5.1,0,9.9,0.4,14.5,1.1c4.6,0.7,9.6,2.2,15.3,4.4
    c-0.2,4.3-1,8.6-2.4,12.6c-1.4,4.1-2.8,7.7-4.3,10.7c-2.1-0.7-4.1-1.4-5.8-1.9c-1.7-0.5-3.4-1-5-1.3s-3.2-0.6-4.8-0.7
    s-3.3-0.2-5.1-0.2c-8.6,0-15.2,2.9-19.9,8.7C158.6,429.4,156.2,438,156.2,449.4z"
                        />
                        <path
                          d="M270.8,436.5c4.4,1.8,8.4,3.6,12,5.5c3.5,1.9,6.6,4.1,9.1,6.7c2.5,2.6,4.5,5.7,5.9,9.4c1.4,3.7,2.1,8.1,2.1,13.3
    c0,5.6-1,10.7-2.9,15.2c-2,4.5-4.8,8.4-8.7,11.6c-3.8,3.2-8.5,5.7-14.1,7.5c-5.6,1.7-11.9,2.6-19.1,2.6c-6.6,0-12.4-0.5-17.4-1.6
    c-5-1.1-10.5-2.7-16.3-4.9c0.4-3.7,1.2-7.7,2.2-11.8c1.1-4.2,2.3-8.4,3.8-12.8c9.7,4.2,18.2,6.4,25.4,6.4c5.4,0,9.6-0.8,12.6-2.5
    c3-1.6,4.5-4.5,4.5-8.5c0-1.7-0.3-3.2-1-4.4c-0.6-1.2-1.5-2.2-2.5-3.1c-1.1-0.8-2.3-1.6-3.6-2.1c-1.3-0.6-2.7-1.1-4.1-1.7l-8.9-3.3
    c-3.8-1.4-7.3-3-10.4-4.9c-3.1-1.9-5.8-4.2-8-6.8c-2.2-2.6-3.9-5.6-5.2-9c-1.2-3.4-1.8-7.4-1.8-11.9c0-5.6,1-10.6,2.9-14.9
    c1.9-4.3,4.6-8,8-11c3.4-3,7.6-5.3,12.5-6.8c4.9-1.5,10.3-2.3,16.4-2.3c5.4,0,10.6,0.5,15.7,1.6c5,1.1,10.4,2.6,16.1,4.6
    c-0.4,3.4-1.2,7.1-2.3,11.2c-1.1,4.1-2.5,7.9-4.2,11.5c-2.8-1.2-6-2.4-9.7-3.7c-3.7-1.3-8.3-1.9-13.8-1.9c-1.7,0-3.3,0.2-4.8,0.5
    c-1.5,0.3-2.9,0.8-4.1,1.5c-1.2,0.7-2.2,1.6-2.9,2.9c-0.7,1.2-1.1,2.7-1.1,4.5c0,3.1,1,5.3,3,6.8c2,1.5,4.4,2.8,7.2,3.8
    L270.8,436.5z"
                        />
                        <path
                          d="M354.5,469.3l21.8-76.9c2.4-0.4,4.9-0.7,7.4-1c2.5-0.2,5.1-0.3,7.9-0.3c1.8,0,4,0.1,6.7,0.4c2.6,0.3,5,0.6,7,0.9L368.7,506
    c-2.8,0.4-5.3,0.7-7.7,1c-2.4,0.2-4.7,0.3-6.9,0.3c-2.1,0-4.3-0.1-6.5-0.3c-2.2-0.2-4.9-0.5-7.9-1l-36.4-113.6
    c1.8-0.3,4.2-0.6,7.1-0.9c3-0.3,5.8-0.4,8.6-0.4c2.2,0,4.7,0.1,7.3,0.4c2.6,0.3,5,0.6,7,0.9L354.5,469.3z"
                        />
                      </g>
                    </svg>
                  </a>
                </li>
              )}
              {/* <li
                title={`${formatMessage('show_completed_trays')}`}
                className="d-flex align-items-center g-2 ms-4 ps-1 show-group"
              >
                <BsForm.Check
                  type="switch"
                  id="custom-switch"
                  className="btn"
                  checked={showCompletedTrays}
                  readOnly
                  onClick={(e: any) => toggleShowCompletedTrays(e)}
                />
                <p className="auto-refresh text-white">
                  {formatMessage('show_completed_trays')}
                </p>
              </li> */}
              <ul className="tableAccordian-switch d-flex">
                <li
                  className={!showCompletedTrays ? 'active' : ''}
                  onClick={(e: any) => toggleShowCompletedTrays(e, false)}
                >
                  <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    id="fi_18975621"
                  >
                    <g
                      clip-rule="evenodd"
                      fill-rule="evenodd"
                    >
                      <path d="m11.5 22v-20h1v20z"></path>
                      <path d="m22 12.5h-20v-1h20z"></path>
                      <path d="m1.5 2c0-.27614.22386-.5.5-.5h20c.2761 0 .5.22386.5.5v20c0 .2761-.2239.5-.5.5h-20c-.27614 0-.5-.2239-.5-.5zm1 .5v19h19v-19z"></path>
                    </g>
                  </svg>
                  <span className="icon-text">
                    {formatMessage('default_view')}
                  </span>{' '}
                </li>
                <li
                  className={showCompletedTrays ? 'active' : ''}
                  onClick={(e: any) => toggleShowCompletedTrays(e, true)}
                >
                  <svg
                    id="fi_18450767"
                    enable-background="new 0 0 100 100"
                    viewBox="0 0 100 100"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="m77.5180588 9.9200459h-55.0361195c-3.0706234 0-5.7967033 1.964983-6.7675276 4.8780966l-12.8484966 38.5539388c-.2423596.7272415-.3659163 1.4887886-.3659163 2.2553482v27.3390808c0 3.9396896 3.1937516 7.1334457 7.1334438 7.1334457h80.7331085c3.9397004.0000001 7.1334489-3.193756 7.1334489-7.1334457v-27.3390808c0-.7665596-.123558-1.5281067-.3659134-2.2553482l-12.8484955-38.5539389c-.9708252-2.9131136-3.696907-4.8780965-6.7675323-4.8780965zm-13.8581467 44.5300273c-1.1899414 2.5300293-3.0499268 4.75-5.3898926 6.3498535-2.3300781 1.6000977-5.1500244 2.5600587-8.2700195 2.5600587-5.9399414 0-11.2800293-3.5600586-13.6599121-8.9099121h-22.2600107l10.6899424-32.6501465h50.4599609l10.6899414 32.6501465h-22.2600098z"></path>
                  </svg>{' '}
                  <span className="icon-text">
                    {formatMessage('show_completed_trays')}
                  </span>
                </li>
              </ul>

              <li title={formatMessage('history')}>
                <a
                  className="btn btn-primary btn-blue d-flex align-items-center"
                  data-toggle="modal"
                  data-testid="modalbtn"
                  data-target="#addUser"
                  onClick={toggleHistoryDetails}
                >
                  <span className="me-1">
                    {' '}
                    <HistoryIcon />
                  </span>
                  <FormattedMessage id="history" />
                </a>
              </li>
              {isOperationPermittedRoleBase(
                ModuleType.TrayManagement,
                'Add'
              ) && (
                <li title={formatMessage('add_tray')}>
                  <a
                    className="btn btn-secondary"
                    data-toggle="modal"
                    data-testid="modalbtn"
                    data-target="#addUser"
                    onClick={(event: any) =>
                      openAddTrayHandler({ Id: -1 }, event)
                    }
                  >
                    <span className="me-1">
                      {' '}
                      <PlusIcon />
                    </span>
                    <FormattedMessage id="add_tray" />
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
      <div className={`${openPanel ? 'panelOpen' : ''}`}>
        <div className="card card-page">
          {(getTrayListServiceState.inProgress ||
            trayState.inProgress ||
            deleteTrayState.inProgress ||
            addUpdateTrayState.inProgress ||
            getTrayFilesHistoryState.inProgress ||
            getDownloadrayFilesHistoryState.inProgress) && (
            <FormLoader
              loading={
                getTrayListServiceState.inProgress ||
                trayState.inProgress ||
                deleteTrayState.inProgress ||
                addUpdateTrayState.inProgress ||
                getTrayFilesHistoryState.inProgress ||
                getDownloadrayFilesHistoryState.inProgress
              }
            />
          )}
          {allTrayListData && allTrayListData.length > 0 ? (
            <>
              <div>
                {/* {duplicateData && duplicateData.length > 0 && (
                  <div className="duplicated-data">
                    <DuplicateAlert
                      duplicateData={`${formatMessage('records_already_exist')} ${duplicateData}`}
                    />
                  </div>
                )} */}

                <div className="tableDesign row-eq-height tableDevices p-3 changingPanel">
                  <div
                    className="table-responsive tray-management-table"
                    data-testid="table"
                  >
                    {allTrayListData && (
                      <Grid
                        data={allTrayListData}
                        columns={columns}
                        keyField="Id"
                        loading={false}
                        rowClasses={rowClassFormat}
                        rowEvents={{ onClick: rowEvents }}
                        hover={true}
                        sort={{ ...columSortOrder }}
                        remote={{ sort: true }}
                        onTableChange={handleTableChange}
                      />
                    )}
                  </div>
                </div>
              </div>
              {allTrayListData.length > 0 ? (
                <div className="row no-gutters p-3 pt-0 tableFooter">
                  <div className="col-lg-3 col-md-6 col-sm-6 pt-1">
                    <FormattedMessage id="show" />
                    <select
                      data-testid="pageSelect"
                      className="pageLimit"
                      onChange={onPageLimitChanged}
                      value={pageLimitInfo.pageLimit}
                    >
                      {pageLimitOptions.map((op: any) => (
                        <option
                          key={op}
                          value={op}
                        >
                          {op}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-9 col-md-6 col-sm-6 d-flex justify-content-sm-end">
                    <Pagination
                      isRefreshPage={false}
                      totalPages={pageInfo.totalPages}
                      pageLimit={pageLimitInfo.pageLimit}
                      onPageChanged={onPageChanged}
                      disablePagination={disablePagination}
                      setIsRefreshPage={setIsRefreshPage}
                      currentPage={pageInfo.currentPage}
                      totalRecords={trayList.PagingDetails.TotalRecords}
                    />
                  </div>
                </div>
              ) : (
                ''
              )}
            </>
          ) : (
            <div className="message">
              <div className="d-flex message-area">
                <div className="no-data-img">
                  <img
                    src={noMessageIcon}
                    alt=""
                    className="no_message"
                  />
                </div>
                <div>
                  <h3 className="fw-bold display-6">
                    {' '}
                    {showCompletedTrays ? (
                      <FormattedMessage id="no_tray_completed" />
                    ) : (
                      <FormattedMessage id="no_tray" />
                    )}
                  </h3>
                  <h4 className="mb-3">
                    {showCompletedTrays
                      ? formatMessage('no_tray_completed_message')
                      : formatMessage('no_tray_message')}
                  </h4>

                  {isOperationPermittedRoleBase(
                    ModuleType.TrayManagement,
                    'Add'
                  ) && (
                    <>
                      <a
                        className="btn btn-primary"
                        onClick={(event: any) =>
                          openAddTrayHandler({ Id: -1 }, event)
                        }
                      >
                        <span className="me-1">
                          {' '}
                          <PlusIcon />
                        </span>
                        <FormattedMessage id="add_tray" />
                      </a>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* <div className={`${openHistoryPanel ? 'history-pannel' : ''}`}> */}
      <div className="history-pannel">
        <SlidingPanel
          type={'right'}
          isOpen={openPanel}
          noBackdrop={false}
          size={openHistoryPanel ? 100 : 100}
          // backdropClicked={() => setOpenPanel(false)}
        >
          <div className="bg_slide panel ">
            <div className="row bb p-2 pl-4 g-0 align-items-center ">
              <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10">
                <h2 className="fw-bold mb-0 mt-1 ms-2 py-2">
                  {!openHistoryPanel ? (
                    selectedRow.TrayId
                  ) : (
                    <FormattedMessage id="history" />
                  )}
                </h2>
              </div>
              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 close-icon-detail">
                <span title={formatMessage('close')}>
                  <CloseSidePanelIcon closePanelHandler={closePanelHandler} />
                </span>
              </div>
            </div>
            <div className="group_detailsWrapper tray-detail pb-3">
              {!openHistoryPanel ? (
                <TrayDetails selectedRowId={selectedRow.Id} />
              ) : (
                <div className="tray-detail">
                  <TrayPrintFilesHistoryDetails />
                </div>
              )}
            </div>
          </div>
        </SlidingPanel>
      </div>
    </>
  );
};

export default ImportTrayDetailsPopupHOC(
  FilterPopupHOC(
    AddEditTrayManagementPopupHOC(DeletePopupHOC(observer(TrayManagement)))
  )
);
